<div class="govuk-width-container">
    <div class="row">
        <nav class="col-12 col-md-4" aria-label="Side navigation">
            <app-menu></app-menu>
        </nav>

        <main class="govuk-main-wrapper col-12 col-md-8 pt-0" id="main-content" tabindex="-1">
            <h1 class="govuk-heading-xl">Terms &amp; Conditions</h1>
            <app-custom-object-banner page="terms-and-conditions"></app-custom-object-banner>
            <app-custom-object-accordion page="terms-and-conditions"></app-custom-object-accordion>
        </main>
    </div>
</div>